import { ComponentProps } from "react";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";
import {
  AsyncSimpleSelectV2,
  ButtonV2,
  InputDateRHFV2,
  MessageErroFormV2,
} from "../../Atoms";
import { IItineranteListProps } from "../../../types/itinerante";
import { useFormFilterItineranteV2 } from "./useFormFilterItineranteV2";

interface IFormFilterItineranteV2Props extends ComponentProps<"form"> {
  submitForm: (data: IItineranteListProps) => void;
}

export const FormFilterItineranteV2 = ({
  submitForm,
  className,
  ...rest
}: IFormFilterItineranteV2Props) => {
  const { Controller, control, handleSubmit, errors, getCidades } =
    useFormFilterItineranteV2();

  return (
    <form
      {...rest}
      onSubmit={handleSubmit(submitForm)}
      className={twMerge(
        "w-full flex flex-col sm:flex-row gap-4 items-end",
        className,
      )}
    >
      <Controller
        control={control}
        name="dataInicio"
        render={({ field: { onChange, value } }) => (
          <InputDateRHFV2
            id="dataInicio"
            label="Data Inicial"
            selected={value ? dayjs(value).toDate() : null}
            onChange={(e) =>
              e ? onChange(dayjs(e).format("YYYY-MM-DD")) : onChange("")
            }
          />
        )}
      />

      <Controller
        control={control}
        name="dataFim"
        render={({ field: { onChange, value } }) => (
          <InputDateRHFV2
            id="dataFim"
            label="Data Final"
            selected={value ? dayjs(value).toDate() : null}
            onChange={(e) =>
              e ? onChange(dayjs(e).format("YYYY-MM-DD")) : onChange("")
            }
          />
        )}
      />

      <div className="w-full">
        <Controller
          control={control}
          name="cidade"
          render={({ field: { onChange, value } }) => (
            <AsyncSimpleSelectV2
              inputId="cidade"
              label="Cidade"
              required
              loadOptions={getCidades}
              defaultOptions
              classNames={{
                control: () => "rounded-lg border-[#2d2d2d]",
              }}
              onChange={(e) => onChange(e?.value)}
              value={value ? { value, label: value } : null}
            />
          )}
        />
        {errors?.cidade && (
          <MessageErroFormV2>{errors.cidade.message}</MessageErroFormV2>
        )}
      </div>

      <ButtonV2 type="submit" className="shrink-0">
        <img src="/assets/svgs/icon-search.svg" alt="" className="h-4 w-4" />
        Buscar
      </ButtonV2>
    </form>
  );
};
